import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, isRef as _isRef, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "select_styled" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["value"]
const _hoisted_4 = ["value"]

import { computed, withDefaults } from 'vue';
import { ListOption } from '@/utility/ListOptions';


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectBoxNum',
  props: {
    modelValue: null,
    list: null,
    disabled: { type: Boolean },
    defaultOpt: null,
    class: null,
    placeholder: null
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: number): void;
  (e: 'change'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: number, list: ListOption<number>[], disabled?: boolean, defaultOpt?: ListOption<number>, class?: string, placeholder?: string }




const model = computed({
  get: () => props.modelValue,
  set: value => emit('update:modelValue', value),
});

const disabled = computed(() => props.disabled);
const list = computed(() => props.list);
const defaultOpt = computed(() => props.defaultOpt);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("select", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) ? (model).value = $event : null)),
      class: _normalizeClass(props.class),
      disabled: _unref(disabled),
      onChange: _cache[1] || (_cache[1] = ($event: any) => (emit('change')))
    }, [
      (_unref(defaultOpt))
        ? (_openBlock(), _createElementBlock("option", {
            key: 0,
            value: _unref(defaultOpt).value,
            selected: "",
            disabled: ""
          }, _toDisplayString(_unref(defaultOpt).text), 9, _hoisted_3))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item) => {
        return (_openBlock(), _createElementBlock("option", {
          key: item.value,
          value: item.value
        }, _toDisplayString(item.text), 9, _hoisted_4))
      }), 128))
    ], 42, _hoisted_2), [
      [_vModelSelect, _unref(model)]
    ])
  ]))
}
}

})